/* A check that has not produced findings, opened in the centre pane.
 *
 * It is shaped like a finding — a claim you can read, a line of context, then
 * the thing to do about it — because it occupies the same place in the same
 * list and a reviewer should not have to learn a second layout to meet it. It
 * is never *dressed* as a finding: there is no evidence badge, no receipt and
 * no disposition, because nothing has been established yet. */

import type { ReactNode } from 'react';

import { Label } from '../primitives';
import type { PendingCheckRow } from './reconcileModel';
import './PendingCheckCard.css';

export interface PendingCheckCardProps {
  row: PendingCheckRow;
  /** The ask, or the plain statement of what did not happen. */
  children: ReactNode;
}

export default function PendingCheckCard({ row, children }: PendingCheckCardProps) {
  return (
    <article
      id={row.id}
      className={`pc pc--${row.state}`}
      aria-labelledby={`${row.id}-title`}
    >
      <div className="pc__head">
        <Label mono>{row.mark}</Label>
        {/* Focusable for the same reason a finding's title is: it is where
            focus lands when the list moves here. */}
        <h2 className="pc__title" id={`${row.id}-title`} tabIndex={-1}>
          {row.claim}
        </h2>
        <p className="pc__context">{row.contextLine}</p>
      </div>

      {children}
    </article>
  );
}
